module.exports = __webpack_public_path__ + "static/img/3.122dc52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oc/3.jpg
// module id = c0jj
// module chunks = 2